import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MagnifyImage } from '../../../CommonComponents/MagnifyImage';
import { RxCross1 } from "react-icons/rx";
import { InputPopup } from '../../../CommonComponents/InputPopup';
import { SuccessPopUp } from '../../../CommonComponents/SuccessPopUp';
import OrderPrint from './OrdersPrint';
import { AssignTrackingId } from './AssignTrackingId';
import { useRole } from '../../../../../Routing/Routing';
import { LoadingWait } from '../../../CommonComponents/LoadingWait';


function OrderDetail() {

  const id = useLocation();
  const { objectId, fromPage } = id.state || {};

  const { userPermissions } = useRole();
  const permission = (url) => userPermissions.includes(url);
  const BASE_URL = process.env.REACT_APP_PP_URL;
  const token = sessionStorage.getItem('tokenKey');

  const [info, setInfo] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const detail = async () => {
    setIsLoading(true);

    try {
      const res = await fetch(`${BASE_URL}/admin/v1/order/getOrderDetail/${objectId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      const getRes = await res.json();
      if (getRes.errorCode === 0) {
        setInfo(getRes.responsePacket);
        const amount = getRes.responsePacket?.itemDetailList?.reduce((total, item) => {
          return total + item.quantity * item?.sellingPrice
        }, 0);
        setTotalAmount(Number(amount));
        setOrderNotes(getRes.responsePacket?.notes);
      }
    } catch (e) {
      console.log(e, 'error in detail api of cart')
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    detail();
  }, []);


  const [showPopup, setShowPop] = useState(false);
  const [message, setMessage] = useState();
  const [getId, setGetId] = useState();
  // const [trackId, setTrackId] = useState();

  // this is update order list 
  // const orderStatus = async (orderId, orderStatus) => {
  //   try {
  //     const res = await fetch(`${BASE_URL}/admin/v1/order/updateOrderStatus/${orderId}/${orderStatus}`, {
  //       method: "PUT",
  //       headers: {
  //         'Authorization': `Bearer ${token}`,
  //       }
  //     });
  //     const getRes = await res.json();
  //     if (getRes.errorCode === 0) {

  //     }
  //   } catch (e) {
  //     console.log(e, 'error in update order list statues');
  //   }
  // };

  const [showErrorPop, setShowErrorPop] = useState(false);
  const [action, setAction] = useState();

  const [cancelReason, setCancelReason] = useState('')
  const trackingId = async (orderId) => {
    try {
      const url = fromPage === "historyOrder" ? 'cancelHistoryOrder' : 'cancelOrder'
      const res = await fetch(`${BASE_URL}/admin/v1/order/${url}/${orderId}`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          cancelReason: cancelReason
        })
      });
      const getRes = await res.json();
      if (getRes.errorCode === 0) {
        setShowPop(false);
        detail();
        setShowErrorPop(true);
        setAction(getRes.message);
      } else {
        setShowErrorPop(true);
        setAction(getRes.message);
        setShowPop(false);
      }
    } catch (e) {
      console.log(e, 'error in tracking id api');
    }
  };

  const handleStatus = (id) => {
    setGetId(id);
    setShowPop(true);
    setMessage('Reason for cancel');
  };

  const handleOk = () => {
    if (getId && cancelReason) {
      trackingId(getId);
    }
  };
  const handleCancle = () => {
    setShowPop(false);
    setGetId('');
    setCancelReason('');
  };

  const [showMultiInputs, setShowMultiInputs] = useState(false);
  const [multiTrackId, setMultiTrackId] = useState([]);

  const handleSingleTrackId = (itemId, itm) => {
    setMultiTrackId((prev) => {
      const exists = prev.find((item) => item.orderId === itemId);
      if (exists) {
        // If the orderId already exists, remove it (uncheck)
        return prev.filter((item) => item.orderId !== itemId);
      } else {
        // If the orderId doesn't exist, add a new object
        return [...prev, { orderId: itemId, updateOrderDetails: { orderTrackingId: itm?.orderTrackingId ? itm.orderTrackingId : '', courierPartnerId: itm?.courierPartnerDetail?.parentUuid ? itm?.courierPartnerDetail?.parentUuid : "" } }];
      }
    });
    setShowMultiInputs(true)
  };
  const removeOrderTrackID = (orderId) => {
    setMultiTrackId((prev) => {
      const exists = prev.find((item) => item.orderId === orderId);
      if (exists) {
        return prev.filter((item) => item.orderId !== orderId);
      }
    });
  };

  const updateOrderTarckingIds = async () => {
    try {
      const res = await fetch(`${BASE_URL}/admin/v1/order/updateOrdersTrackingId`, {
        method: "PUT",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(multiTrackId)
      });

      const getRes = await res.json();
      if (getRes.errorCode === 0) {
        setShowMultiInputs(false);
        setMultiTrackId([]);
        setShowErrorPop(true);
        setAction('Tracking ID assign successfully');
      } else {
        setShowErrorPop(true);
        setAction(getRes.message);
        setShowMultiInputs(false);
      }
    } catch (e) {
      console.log(e, "error in update tracking ids");
      setShowErrorPop(true);
      setShowMultiInputs(false);
      setAction(e);
    }
  };
  // print
  const [showPrintPreview, setShowPrintPreview] = useState(false);

  // Image Magifinify
  const [imgUrl, setImgUrl] = useState();
  const [showImg, setShowImg] = useState(false);
  const maginifyImage = (e) => {
    setShowImg(true);
    setImgUrl(e);
  };

  const navigate = useNavigate();

  const timeFormate = (time) => {
    try {
      // Check if the time is valid
      const date = new Date(time);
      if (isNaN(date)) {
        throw new Error("Invalid date");
      }

      const options = {
        day: 'numeric',    // 5
        month: 'numeric',    // Dec
        year: 'numeric',   // 2024
        hour: '2-digit',   // 10
        minute: '2-digit',
        hour12: true
      };

      const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);
      return formattedDate;
    } catch (error) {
      console.error("Invalid time value:", error.message);
      return "Invalid Date";
    }
  };
  const [cancelItem, setCancelItem] = useState(false);
  const handleCancelItem = () => {
    setCancelItem(true);
  };

  const [refundAmount, setRefundAmount] = useState('');
  const [itemIds, setItemIds] = useState([]);

  const handleCheck = (itemId) => {
    setItemIds((prevSelected) =>
      prevSelected.includes(itemId)
        ? prevSelected.filter((id) => id !== itemId) // Uncheck if already selected
        : [...prevSelected, itemId] // Add to selected items
    );
  };

  const [totalAmount, setTotalAmount] = useState(0);
  const particalCancel = async () => {
    setIsLoading(true);
    const url = fromPage === "historyOrder" ? 'partialCancelHistoryOrder' : 'partialCancelOrder'
    try {
      const token = sessionStorage.getItem('tokenKey');
      const res = await fetch(`${BASE_URL}/admin/v1/order/${url}/${objectId}`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          itemIds: itemIds,
          shippingRefundAmount: Number(refundAmount),
        })
      });
      const getRes = await res.json();
      if (getRes.errorCode === 0) {
        alert("Partial Refund success");
        setCancelItem(!cancelItem);
        detail();
        setCancelItem(false);
      } else {
        alert(getRes.message)
      }
    } catch (e) {
      console.log(e, "error in partialCancel");
    } finally {
      setIsLoading(false);
    }
  };

  // orders Notes
  const [orderNotes, setOrderNotes] = useState('');
  const orderNotesPost = async () => {
    setIsLoading(true);
    try {
      // /admin/v1/order/saveHistoryOrderNotes/{orderId}
      const token = sessionStorage.getItem('tokenKey');
      const url = fromPage === "historyOrder" ? "saveHistoryOrderNotes" : "saveOrderNotes"
      const res = await fetch(`${BASE_URL}/admin/v1/order/${url}/${objectId}`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderNotes: orderNotes
        })
      })
      const getRes = await res.json();
      if (getRes.errorCode === 0) {

      }
    } catch (e) {
      console.log(e, "error in order Notes");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="category">
        <div className="row">
          <div className="category" style={{ display: "block", }}>
            <div className="category-nav" >
              <div className="category-text">
                <h4>Order Detail</h4>
              </div>
              <div className="category-btn">
                <button className='btn' onClick={() => navigate(-1)}><RxCross1 /></button>
              </div>
            </div>
            <hr />
          </div>
          <div className="" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              {permission('admin/v1/order/updateOrderTrackingId') && !info?.courierPartnerDetail?.parentUuid && !info?.orderTrackingId && <button style={{ backgroundColor: "black", color: "white", padding: "10px", margin: "5px" }} onClick={() => handleSingleTrackId(info?.orderId, info)} > Assign Track ID</button>}
              <button style={{ backgroundColor: "black", color: "white", padding: "10px", margin: "5px" }} onClick={() => { setShowPrintPreview(true) }}>Print Slip</button>
              {permission('admin/v1/order/cancelOrder') && info?.orderStatus !== "CANCELLED" && <button style={{ backgroundColor: "black", color: "white", padding: "10px", margin: "5px" }} onClick={() => { handleStatus(info?.orderId) }}>Cancel Order</button>}
              {info?.orderStatus === "CANCELLED" && <button style={{ backgroundColor: "black", color: "white", padding: "10px", margin: "5px" }}>Order Cancelled</button>}
            </div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
              {cancelItem &&
                <>
                  <label htmlFor="refend">Refund Amount : </label>
                  <input type="number" max={totalAmount} id='refend' value={refundAmount}
                    onChange={(e) => {
                      let value = Number(e.target.value);
                      if (value > totalAmount) value = totalAmount;
                      if (value < 0) value = 0;
                      setRefundAmount(isNaN(value) ? '' : value);
                    }} style={{ fontSize: "1.1rem", padding: "4px" }}
                    onKeyDown={(e) => {
                      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                        e.preventDefault();
                      }
                    }}
                    onWheel={(e) => e.target.blur()}
                  />
                </>
              }
              {cancelItem ?
                <button style={{ backgroundColor: "black", color: "white", padding: "10px", margin: "5px" }} onClick={particalCancel}>Refund Items</button>
                :
                (info?.itemDetailList?.length > 1 && <button style={{ backgroundColor: "black", color: "white", padding: "10px", margin: "5px" }} onClick={handleCancelItem}>Partial Refund</button>)}

            </div>
          </div>
        </div>
      </div>

      <div className="order-detail">
        <div className="order-detail-flex">
          <div className="ordered-item-container">
            <div className="card-b">
              <h3 className="card-title">Ordered Item Details</h3>
              <table className="item-table">
                <thead>
                  <tr>
                    {cancelItem && <th>Sr.</th>}
                    <th>Image</th>
                    <th>Title</th>
                    <th>MRP</th>
                    <th>Selling Price</th>
                    <th>Qty.</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>

                  {info?.itemDetailList?.map((item, index) => (
                    <tr key={item.id}>
                      {cancelItem && <td>
                        <input type="checkbox" name="" id="" onChange={() => handleCheck(item?.itemUuid)} checked={itemIds.includes(item.itemUuid)} />
                      </td>}
                      <td>
                        <div className="img" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <img src={item?.itemImageUrls?.[0]} alt="img" style={{ width: "100%", height: "100px", }} onClick={() => maginifyImage(item?.itemImageUrls?.[0])} loading="lazy" />
                        </div>
                      </td>
                      <td>
                        {item.title} <span className="info-icon"></span>
                      </td>
                      <td>{item.mrp}</td>
                      <td>{item.sellingPrice}</td>
                      <td>{item.quantity}</td>
                      <td>{item.sellingPrice * item.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Order Summary */}
              <div className="summary">
                <div className="summary-row">
                  <span>Item Total</span>
                  <span>{info?.subTotal}</span>
                </div>
                {Number(info?.couponDiscountAmount) > 0 && <div className="summary-row">
                  <span>Coupon Discount</span>
                  <span className="negative">{info?.couponDiscountAmount}</span>
                </div>}
                {Number(info?.deliveryCharges) > 0 && <div className="summary-row">
                  <span>Delivery Charges</span>
                  <div>
                    <div>{info?.deliveryCharges}</div>
                  </div>
                </div>}
                {Number(info?.packingCharges) > 0 && <div className="summary-row">
                  <span>Packing Charges</span>
                  <div>
                    <div>{info?.packingCharges}</div>
                  </div>
                </div>}
                {Number(info?.itemAmountRefund) > 0 && <div className="summary-row">
                  <span>Item Amount Refund</span>
                  <div>
                    <div>{info?.itemAmountRefund}</div>
                  </div>
                </div>}
                {Number(info?.shippingAmountRefund) > 0 && <div className="summary-row">
                  <span>Shipping Amount Refund</span>
                  <div>
                    <div>{info?.shippingAmountRefund}</div>
                  </div>
                </div>}
                <div className="summary-row total">
                  <span>Order Total</span>
                  <span>{info?.orderTotal}</span>
                </div>
              </div>
            </div>
          </div>
          {/* Shipping Address */}
          <div className="card" style={{ marginLeft: "15px", maxHeight: "420px", marginTop: "20px" }}>
            <h3 className="card-title">Shipping Address</h3>
            <div className="row">
              <span className="label">Full Name:-  </span>
              <span className="value">{info?.customerAddressDetail?.firstName} {info?.customerAddressDetail?.lastName}</span>
            </div>
            <div className="row">
              <span className="label">Address:-  </span>
              <span className="value">{info?.customerAddressDetail?.addressLine1}, {info?.customerAddressDetail?.landMark}</span>
            </div>
            <div className="row">
              <span className="label">City:-  </span>
              <span className="value">{info?.customerAddressDetail?.cityTitle}</span>
            </div>
            <div className="row">
              <span className="label">PinCode:-  </span>
              <span className="value">{info?.customerAddressDetail?.pinCode}</span>
            </div>
            <div className="row">
              <span className="label">State:-  </span>
              <span className="value">{info?.customerAddressDetail?.stateTitle}</span>
            </div>
            <div className="row">
              <span className="label">Mobile Number:-  </span>
              <span className="value">{info?.customerAddressDetail?.mobileNumber}</span>
            </div>
          </div>

        </div>
        <div className="container">
          <div className="card">
            <h3 className="card-title">Customer Details</h3>
            <div className="row">
              <span className="label">Full Name:-  </span>
              <span className="value">{info?.customerDetail?.userCustomerFirstName} {info?.customerDetail?.userCustomerLastName}</span>
            </div>
            <div className="row">
              <span className="label">Mobile Number:-  </span>
              <span className="value">{info?.customerDetail?.userCustomerIsdCode}{info?.customerDetail?.userCustomerMobile}</span>
            </div>
            <div className="row">
              <span className="label">Email:-  </span>
              <span className="value">{info?.customerDetail?.userCustomerEmail}</span>
            </div>
          </div>

          {/* Order Detail */}
          <div className="card" >
            <h3 className="card-title">Order Detail</h3>
            <div className="row">
              <span className="label">Order Reference #:-  </span>
              <span className="value">{info?.orderId}</span>
            </div>
            {info?.orderTrackingId && <div className="row">
              <span className="label">Order Tracking ID #:-  </span>
              <span className="value">{info?.orderTrackingId}</span>
            </div>}
            <div className="row">
              <span className="label">Order Date Time:-  </span>
              <span className="value">{
                info?.orderStatus === "ORDER" ? timeFormate(info?.createdAt) : timeFormate(info?.orderAt)
              }</span>
            </div>
            <div className="row">
              <span className="label">Payment Type:-  </span>
              <span className="value">{info?.paymentType}</span>
            </div>
            <div className="row">
              <span className="label">Payment Status:-  </span>
              <span className="value">{info?.paymentStatus}</span>
            </div>
            <div className="row">
              <span className="label">Order Total:-  </span>
              <span className="value">{info?.orderTotal}</span>
            </div>
          </div>

          {/* Ordered Status */}
          <div className="card">
            <h3 className="card-title">Ordered Status</h3>
            <table className="table">
              <thead>
                <tr>
                  <th>Sr #</th>
                  <th>Status</th>
                  <th>Recorded At</th>
                </tr>
              </thead>
              <tbody>
                {info?.orderStatusLogList?.map((status, index) => (
                  <tr key={status.id}>
                    <td>{index + 1}</td>
                    <td>{status.orderStatusEnum}</td>
                    <td>{timeFormate(status.modifiedAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {info?.courierPartnerDetail?.parentUuid ? <div className="card">
            <h3 className="card-title">Courier Partner Details</h3>
            <table className="table" style={{ width: "90%" }}>
              <thead>
                <tr>
                  {/* <th>Sr #</th> */}
                  <th>ID</th>
                  <th>URL</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {/* <td>{index + 1}</td> */}
                  <td>{info?.courierPartnerDetail?.parentUuid}</td>
                  <td>{info?.courierPartnerDetail?.parentTitle}</td>
                </tr>
              </tbody>
            </table>
          </div>
            :
            <div className="card">
              <h3 className="card-title">{fromPage === "historyOrder" ? "History Order Notes" : "Order Notes"}</h3>
              <textarea value={orderNotes} onChange={(e) => setOrderNotes(e.target.value)} style={{ width: "100%", height: "290px", padding: "10px", fontSize: "1rem" }} ></textarea>
              <div className="btn-div">
                <button onClick={orderNotesPost}>Submit</button>
              </div>
            </div>
          }
        </div>

        {info?.courierPartnerDetail?.parentUuid && <div className="container">
          <div className="card">
            <h3 className="card-title">{fromPage === "historyOrder" ? "History Order Notes" : "Order Notes"}</h3>
            <textarea value={orderNotes} onChange={(e) => setOrderNotes(e.target.value)} style={{ width: "100%", height: "290px", padding: "10px", fontSize: "1rem" }} ></textarea>
            <div className="btn-div">
              <button onClick={orderNotesPost}>Submit</button>
            </div>
          </div>
        </div>}
      </div>

      <MagnifyImage isOpen={showImg} imgSrc={imgUrl} onClose={() => setShowImg(false)} />
      <InputPopup
        isOpen={showPopup}
        onOk={handleOk}
        onCancel={handleCancle}
        ok='ok'
        cancel='cancel'
        message={message}
        inValue={cancelReason}
        inChange={setCancelReason}
      />
      <SuccessPopUp
        action={action}
        FutherMore={"OK"}
        onClose={() => { setShowMultiInputs(false); setShowErrorPop(false) }}
        isOpen={showErrorPop}
      />
      <AssignTrackingId
        isOpen={showMultiInputs}
        data={multiTrackId}
        setData={setMultiTrackId}
        removeOrder={removeOrderTrackID}
        onClose={() => { setShowMultiInputs(false); setMultiTrackId([]) }}
        onSubmit={updateOrderTarckingIds}
      />
      {showPrintPreview && <OrderPrint
        orders={[info]}
        isOpen={showPrintPreview}
        allData={[info]}
        onClose={() => setShowPrintPreview(false)}
      />}
      <LoadingWait isTrue={isLoading} />
    </>
  )
}
export default OrderDetail;